export const isMainnet = process.env.REACT_APP_NETWORK === 'mainnet'

export const PROJECT_ID = process.env.REACT_APP_WALLET_CONNECT_ID
